import { Button, Grid, MenuItem, Paper } from "@mui/material";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import { Box, Select } from "@mui/material";
import React, { useEffect } from "react";
import { LeaveDay, useFerieApi } from "../Hooks/useFerieApi";
import config from '../Config/environments';
import { loginRequest } from "../authConfig";

interface InfoPanelProps {
  isUser?: boolean;
  fullWidth?: boolean;
  vacation?: LeaveDay[];
  onActivityTypeUpdate?: (activityType: number) => void;
  showButtons: boolean;
  doneLoading: boolean;
}
const InfoPanel: React.FC<InfoPanelProps> = (props) => {
  const { instance } = useMsal();
  const api = useFerieApi();
  const [name, setName] = React.useState<string | undefined>(undefined);
  const [vacationDays, setVacationDays] = React.useState<number>();
  const [activityTypes, setActivityTypes] = React.useState<Array<{ code: number, name: string }>>([]);
  const [selectedActivityType, setSelectedActivityType] = React.useState<number>(config.holidayCode);
  const isAuthenticated = useIsAuthenticated();

  const handleLogout = () => {
    instance.logoutRedirect();
  };
  const handleLogin = () => {
    instance
      .loginRedirect(loginRequest)
      .then(() => { })
      .catch((e) => {
        console.error(e);
      });
  };
  useEffect(() => {
    if (props.onActivityTypeUpdate) {
      props.onActivityTypeUpdate(selectedActivityType);
    }
  }, [selectedActivityType, props]);

  useEffect(() => {
    if (props.vacation) {
      const vd = props.vacation.filter(v => {
        return v.code === config.holidayCode;
      });
      setVacationDays(vd.length);
    }
  }, [props.vacation]);

  useEffect(() => {
    if (isAuthenticated) {
      api.getActivityTypes().then((x) => {
        setActivityTypes(x || []);
      });
      const accounts = instance.getAllAccounts();
      if (accounts.length > 0) {
        setName(accounts[0]?.name);
      } else {
        setName("");
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [instance, isAuthenticated]);

  return (
    <Paper
      sx={{
        width: props.fullWidth ? "auto" : "300px",
        backgroundColor: "transparent",
        border: "1px solid #6D4646",
        padding: 1,
        marginLeft: props.fullWidth ? 1 : 1,
        marginRight: props.fullWidth ? 1 : undefined,
        boxSizing: "border-box",
        fontSize: "12px",
      }}
    >
      <Grid container sx={{ display: 'flex', flexDirection: "row" }} spacing={2}>
        <Grid >
          {isAuthenticated && <Box sx={{ fontWeight: "bold" }}>{name}</Box>}
          {isAuthenticated && props.isUser && props.doneLoading && <Box>Ferie {vacationDays}/30</Box>}
          {isAuthenticated && props.isUser === false && props.doneLoading && <Box>Fant ikke bruker i PO</Box>}
        </Grid>
        {isAuthenticated && props.isUser &&
          <Select size="small" value={selectedActivityType} onChange={(e) => setSelectedActivityType(Number(e.target.value))}
            sx={{ fontSize: "12px", paddingTop: "0px", marginLeft: 'auto' }} >
            {
              activityTypes.map((at) => (
                <MenuItem key={at.code} value={at.code} sx={{}}>{at.name}</MenuItem>
              ))
            }
          </Select>}
          {(!isAuthenticated || !props.isUser) &&<Box sx={{ marginLeft: 'auto' }}></Box>}

        {props.showButtons && !isAuthenticated && <Button onClick={handleLogin} sx={{ color: "#0E0E0E" }} >Login</Button>}
        {props.showButtons && isAuthenticated && <Button onClick={handleLogout} sx={{ color: "#0E0E0E" }} >Logout</Button>}

      </Grid>
    </Paper>
  );
};

export default InfoPanel;
